import request from '../../request/index'
import sevice from '@/sevice/index'
let api = {
    navList:()=>{
        return request.get(sevice.navUrl)
    }
}
export default  api 